import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Stack,
  styled,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";

import PrgImgFull from "../../assets/homepage/prgImgFull.jpg";
import PrgImgHalf from "../../assets/homepage/prmImgHall.jpg";
import { ArrowForwardRounded } from "@mui/icons-material";

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "50px",
  textTransform: "capitalize",
  padding: "12px 20px",
  height: "3rem",
  color: theme.palette.text.blue,
  fontSize: "1rem",
}));

export default function PartnerProgram() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box
      sx={{
        py: 5,
      }}
    >
      <Container maxWidth="xl" sx={{ px: 2.5 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Grid container spacing={3} gap={{ xs: 5, md: 0 }}>
            <Grid item xs={12} md={6} sx={{ py: "0px !important" }}>
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.8 }}
                style={{ height: sm ? "100%" : "auto" }}
              >
                <CardMedia
                  component="img"
                  image={PrgImgFull}
                  height="100%"
                  alt="BPO Homes"
                  sx={{ borderRadius: 4 }}
                />
              </motion.div>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sx={{ py: "0px !important", pr: "0px !important" }}
            >
              <Stack height="100%" justifyContent="space-between" gap={3}>
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.8 }}
                  style={{ height: sm ? "50%" : "auto" }}
                >
                  <CardMedia
                    component="img"
                    height="100%"
                    image={PrgImgHalf}
                    alt="BPO Homes"
                    sx={{ borderRadius: 4 }}
                  />
                </motion.div>

                <Card
                  sx={{
                    borderRadius: 2,
                    height: { xs: "45vh", md: "50%" },
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "background.alternate.2",
                    color: "white",
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, p: { xs: 2.5, sm: 4 } }}>
                    <Stack height="100%" justifyContent={"space-between"}>
                      <Stack gap={2}>
                        <Typography
                          variant="h4"
                          fontSize={"2rem"}
                          fontWeight="bold"
                        >
                          Join our Partner <br /> Agent Program
                        </Typography>

                        <Typography
                          variant="body1"
                          fontSize={"18px"}
                          sx={{ opacity: 0.9, lineHeight: "1.7" }}
                        >
                          Join our Partner Agent Program, receive referrals from
                          BPO Homes as a Buyer & Listing Agent. Enroll Now for
                          FREE!
                        </Typography>
                      </Stack>

                      <Box>
                        <StyledButton
                          variant="contained"
                          color="inherit"
                          sx={{
                            width: { xs: "100%", md: "auto" },
                          }}
                          onClick={() => {
                            dispatch({ type: "AUTH_TYPE", payload: false });
                            dispatch({ type: "AUTH_LOGIN" });
                          }}
                        >
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Typography variant="body">
                              Sign Up Today
                            </Typography>
                            <ArrowForwardRounded
                              fontSize="small"
                              sx={{
                                color: "primary",
                              }}
                            />
                          </Stack>
                        </StyledButton>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              </Stack>
            </Grid>
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
}
